import { suffixBaseURL } from '@/config/api'
import { httpClient } from '@/shared/infra/adapters/axios/axios'

import { Root } from '../helpers/get-current-user'

export async function getUserInfo(): Promise<Root> {
  const { data } = await httpClient.get<Root>(
    `${suffixBaseURL.myBusiness}/company-infos/list`,
  )

  return data
}
